export const FORM_ID = {
  SUBSCRIBE: 'ffa5a01f-eeec-4731-b5ea-124e648dda22',
};

export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'];
